import { Input } from "@chakra-ui/react";

import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
import { EmailQuestionProps } from "../types";

export const EmailQuestion = (props: EmailQuestionProps) => {
  const {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    className,
    layoutProps,
    questionId,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    placeholder,
    size,
    isDisabled,
    answerAriaLabel,
    changeEventHandler,
    answerProps,
    contentClassName,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps
  } = props;
  const headerFooterProps = {
    spacing,
    isRequired,
    isInvalid,
    questionId,
    labelClassName,
    className,
    layoutProps,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        <Input
          id={questionId}
          className={contentClassName}
          type="email"
          value={answer}
          placeholder={placeholder}
          onChange={changeEventHandler}
          maxLength={maxLength}
          isDisabled={isDisabled}
          aria-label={answerAriaLabel}
          {...answerProps}
          size={size}
        />
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
